"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ms = _interopRequireDefault(require("ms"));

var _lastTimestampFromPricesMap = _interopRequireDefault(require("./last-timestamp-from-prices-map"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const hourMs = (0, _ms.default)('1h');

const cropHistory = ({
  history,
  hourlyLimit
}) => {
  const lastCachedTime = (0, _lastTimestampFromPricesMap.default)(history);
  if (!lastCachedTime) return history;
  const limitedTime = lastCachedTime - hourMs * hourlyLimit;
  return new Map([...history].filter(([key]) => key > limitedTime));
};

var _default = cropHistory;
exports.default = _default;